import { useState } from 'react';

//
import SvgColor from '../../svg-color';
import { StyledCard } from '../styles';

const FullScreenOptions = () => {
  const [fullscreen, setFullscreen] = useState(false);

  const onToggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  return (
    <StyledCard
      onClick={onToggleFullScreen}
      selected={fullscreen}
      sx={{
        '& .svg-color': {
          height: 16,
          ml: 1,
          width: 16,
        },
        height: 48,
        typography: 'subtitle2',
      }}
    >
      {fullscreen ? 'Exit Fullscreen' : 'Fullscreen'}

      <SvgColor
        src={`/assets/icons/setting/${
          fullscreen ? 'ic_exit_full_screen' : 'ic_full_screen'
        }.svg`}
      />
    </StyledCard>
  );
};

export default FullScreenOptions;
